export const AUDIT_LOG_DETAIL_MAP: { [key: string]: { [key: string]: string } } = {
    WaterUser: {
        Code: "Mã HĐ",
        Name: "Đại diện HĐ",
        OrganizationName: "Tên tổ chức",
        TollAreaName: "Khu vực",
        TollAreaId: "",
        Phone: "Điện thoại",
        Bank: "Ngân hàng",
        BankNo: "Số tài khoản",
        WaterMeterCode: "Mã đồng hồ nước",
        Address: "Địa chỉ",
        UserName: "TK đại diện",
        UnitTypeName: "Loại hình đơn vị",
        Status: "Trạng thái",
        LastWaterMeterNumber: "Chỉ số cuối",
        LastReadDate: "Ngày đọc cuối",
        Note: "Ghi chú",
        RequiredDepositAmount: "Số tiền phải cọc",
        DepositAmount: "Số tiền đã nộp",
        Collector: "Người thu tiền",
        CollectionDate: "Ngày thu",
        DepositStatus: "Trạng thái thu",
    },
    AppUser: {
        WaterFactoryId: "",
        IsWaterFactoryAdmin: "",
        Id: "",
        UserName: "Tài khoản",
        FullName: "Họ và tên",
        JobTitle: "Chức vụ",
        IsActive: "Trạng thái",
        Stt: "Stt"
    },
    WaterInvoice: {
        Id: "",
        Stt: "Stt",
        CodeString: "Mã TC",
        Code: "Số TC",
        WaterUserCode: "Mã HĐ",
        WaterUserName: "Tên KH",
        WaterUserPhone: "SĐT",
        Month: "Tháng",
        Year: "Năm",
        StrMonthYear: "Tháng",
        WaterMeterNumber: "CS cuối",
        WaterMeterNumberLast: "CS đầu",
        WaterUserId: "",
        ReadDate: "Đến ngày",
        ReadDateLast: "Từ ngày",
        Amount: "Khối lượng nước",
        Total: "Tiền thanh toán",
        UseTotal: "Tiền trước thuế",
        VatTotal: "Tiền VAT",
        EnviromentFeeTotal: "Tiền phí môi trường",
        AllTotal: "Tổng tiền",
        Discount: "Giảm trừ",
        Status: "TT thanh toán",
        ApproveStatus: "Phê duyệt",
        SendStatus: "Trạng thái gửi",
        SendDate: "Thời gian gửi",
        PayBillCreator: "Người thanh toán",
        PaymentDate: "Thời gian thanh toán",
        EInvoiceNo: "HDĐT",
        EInvoiceStatus: "Trạng thái HDĐT",
        EInvoiceArisingDate: "Ngày phát hành",
    },
    WaterInvoiceRow: {
        Id: "",
        Stt: "Stt",
        Name: "Tên",
        FromAmount: "Chỉ số từ",
        ToAmount: "Chỉ số đến",
        Price: "Giá bán"
    },
    WaterIndex: {
        Id: "",
        Stt: "Stt",
        WaterUserCode: "Mã hợp đồng",
        WaterUserName: "Đại diện hợp đồng",
        WaterUserId: "",
        WaterUserMeterCode: "Mã đồng hồ nước",
        WaterMeterNumber: "Số đồng hồ",
        OldNumber: "Số đo cũ",
        OldUseAmount: "Tiêu thụ cũ",
        UseAmount: "Số lượng sử dụng",
        CreatedAt: "Ngày đo",
        CreatedBy: "Người đo",
        TollAreaName: "Khu vực",
        WaterMeterCode: "Mã đồng hồ",
        DifferenceRatio: "Tỷ lệ chênh lệch",
        Year: "",
        Month: "",
        Image: "",
        WaterUser: ""
    },
    TollArea: {
        Id: "",
        Stt: "Stt",
        Code: "Mã",
        Name: "Tên",
        ProvinceName: "Tỉnh/Thành phố",
        ProvinceId: "",
        DistrictName: "Quận/Huyện",
        DistrictId: "",
        WardName: "Phường/Xã",
        WardId: "",
        ManagerName: "Quản lý",
        ManagerId: "",
        ReaderName: "Người đọc số nước",
        TollCollectorName: "Người thu tiền",
        ExportDate: "Ngày chốt số nước hàng tháng",
        ReaderId: ""
    },
    Transaction: {
        Id: "",
        Stt: "Stt",
        Amount: "Số tiền giao dịch",
        CurrentBalance: "Số dư hiện tại",
        ExtraType: "Loại giao dịch",
        Information: "Thông tin giao dịch",
        CreatedAt: "Thời gian giao dịch",
        CreatedBy: "Người tạo",
        BeneficiaryName: "Người thụ hưởng"
    },
    UnitType: {
        Id: "",
        Stt: "Stt",
        Code: "Mã",
        Name: "Tên",
        FeeLadderName: "Bảng giá áp dụng",
        ProvinceName: "Tỉnh/Thành phố áp dụng",
        RequiredDepositAmount: "Tiền đặt cọc"
    }
};
